import { Control } from "../Control.js";

function width(value) {

    if (value === undefined || value === null)
        return '';
    if (value === 'auto' || value === 'max')
        return '.max';
    if (value === 'shrink' || value === 'min')
        return '.min';

    const numericValue = parseInt(value);
    if (Number.isNaN(numericValue) || numericValue <= 0)
        return '';

    return `.s${numericValue}`;

}

function cellWidth(value) {

    if (value === undefined || value === null || value === 'auto')
        return '';
    if (value === 'shrink' || value === 'min')
        return '.shrink';
    return width(value);

}

class GridCell extends Control {

    constructor(parent, options = {}) {

        options = Object.assign({
            width: 12,
            controls: []
        }, options || {});

        super(parent, options);

        const {
            width = 12,
            controls = [],
        } = options;

        this.width = width;
        this.controls = controls;
        this.controls.forEach((control) => control.parent = this);

    };

    _render(r, vm) {

        const renderer = r;

        var props = {},
            style = (cellWidth(this.width) || '') + (this.getCss() || ''),
            controls = this.controls.map(function (control) {
                if (!control)
                    return null;
                return control.render(renderer, vm);
            });

        return renderer.cell({ css: style, props }, controls);

    };

}

export class Grid extends Control {

    constructor(parent, options = {}) {

        options = Object.assign({
            width: null,
            cells: []
        }, options || {});

        super(parent, options);

        this.width = options.width;
        this.cells = options.cells;

        return this;

    };

    cell(options) {

        options = options || {};

        this.cells.push(new GridCell(this, options));
        return this;

    };

    _render(r, vm) {

        if (!this.isVisible())
            return null;

        const renderer = r;

        var props = {
            vertical: this.vertical,
        },
            style = (width(this.width) || '') + (this.getCss() || ''),
            controls = this.cells.map(function (cell) {
                if (!cell)
                    return null;
                return cell.render(renderer, vm);
            });

        return renderer.grid({ css: style, props }, controls);

    };

}